import { motion } from "framer-motion";
import { Check } from "lucide-react";

const POINTS = [
  { t: "Experienced Business Consultants", d: "Seasoned operators with Fortune 500 track records." },
  { t: "Proven Continuous Improvement Methodologies", d: "Lean, Six Sigma, BPM, and TOC applied pragmatically." },
  { t: "Practical Business Solutions", d: "We don't ship slideware. We ship working operations." },
  { t: "Measurable ROI", d: "Every program has baselines, targets, and a transparent scorecard." },
  { t: "Data-Driven Decisions", d: "Diagnose with data. Decide with rigor. Execute with discipline." },
  { t: "Customized Strategies", d: "No copy-paste playbooks. Tailored to your context and constraints." },
  { t: "End-to-End Support", d: "From assessment to sustainment — we stay until results stick." },
  { t: "Sustainable Business Results", d: "Embed the change. Build internal capability. Compound the gains." },
];

export default function WhyClinivon() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="section-eyebrow mb-5">Why Clinivon</div>
            <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A2540] leading-tight">
              Why organizations trust Clinivon
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed">
              We combine boardroom-grade strategy with shop-floor execution. Practical. Measurable. Sustainable.
            </p>
            <div className="mt-8 flex items-center gap-6 border-l-2 border-[#10B981] pl-5">
              <div>
                <div className="font-display font-bold text-3xl text-[#0A2540] tabular">96%</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider">Client retention</div>
              </div>
              <div>
                <div className="font-display font-bold text-3xl text-[#0A2540] tabular">4.9</div>
                <div className="text-xs text-slate-500 uppercase tracking-wider">Avg. NPS rating</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-7 grid sm:grid-cols-2 gap-4">
            {POINTS.map((p, i) => (
              <motion.div
                key={p.t}
                initial={{ opacity: 0, x: 16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: (i % 4) * 0.05 }}
                className="border border-slate-200 p-5 hover:border-[#10B981] hover:shadow-sm transition-all"
              >
                <div className="flex items-start gap-3">
                  <div className="h-6 w-6 grid place-items-center bg-[#10B981] text-white rounded-full flex-shrink-0 mt-0.5">
                    <Check size={14} strokeWidth={3} />
                  </div>
                  <div>
                    <h4 className="font-display font-semibold text-[#0A2540] text-base mb-1">{p.t}</h4>
                    <p className="text-xs text-slate-500 leading-relaxed">{p.d}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
